export default function DSA_Counting_Sort() {
  return <div>DSA_Counting_Sort Component</div>;
}
